import { render, staticRenderFns } from "./LeftMenuCmp.vue?vue&type=template&id=5abe2b0a&scoped=true&"
import script from "./LeftMenuCmp.vue?vue&type=script&lang=js&"
export * from "./LeftMenuCmp.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenuCmp.vue?vue&type=style&index=0&id=5abe2b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe2b0a",
  null
  
)

export default component.exports